<template>
    <div class="page-category page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="12">
                    <h3 style="float: none;">前台分类</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>商品中心</el-breadcrumb-item>
                            <el-breadcrumb-item>前台分类</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
                <el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
                    <el-button type="primary" class="btn-bg-p" @click="handleCategory('add')">添加 <i class="el-icon-plus"></i></el-button>
                    <!-- <el-button type="primary" class="btn-bg-r" @click="delmultiple()">批量删除</el-button>-->
                </el-col>
            </el-row>
            <div class="bd">
                <div class="search-block content-body">
                    <el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline" @submit.native.prevent>
                        <el-form-item prop="name" label="分类名称：" style="margin-bottom: 0;">
                            <el-input v-model="form_search.name" size="small" placeholder="分类名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="状态：">
                            <el-select size="small" v-model="form_search.status" placeholder="请选择" style="width:100%;">
                                <el-option
                                        v-for="item in init_data.status_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item style="margin-bottom: 0;">
                            <el-button type="primary" class="search-btn"  size="medium" @click='searchList()'>查询</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <el-table ref="multipleTable"
                                  :data="table_data.list"
                                  v-loading="table_data.loading"
                                  tooltip-effect="dark"
                                  :indent="3"
                                  style="width: 100%;text-align: center;"
                                  row-key="id"
                                  default-expand-all
                                  lazy
                                  :load="loadCategory"
                                  @row-click="expandChange"
                                  :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                            <el-table-column prop="name" label="分类名称" min-width="140">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.p_id==0">{{scope.row.name}}</span>
                                    <span v-else >-- {{scope.row.name}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="id" width="55" label="ID" align="center">
                            </el-table-column>
                            <!--<el-table-column prop="p_category_name" align="center" label="所属父级" min-width="120">
                            </el-table-column>-->
                            <el-table-column prop="sort" align="center" label="排序" min-width="120">
                            </el-table-column>
                            <el-table-column prop="status_name" align="center" label="状态" min-width="90">
                                <template slot-scope="scope">
                                    <span :class="'status-'+scope.row.status">{{scope.row.status_name}}</span>
                                </template>
                            </el-table-column>
                            <!--<el-table-column prop="update_time" align="center" sortable label="更新时间" min-width="180">-->
                            <!--</el-table-column>-->
                            <!--<el-table-column prop="c_time" align="center" sortable label="创建时间" min-width="180">-->
                            <!--</el-table-column>-->
                            <el-table-column prop="operating" align="right" label="操作" min-width="200" fixed="right">
                                <template slot-scope="scope">
                                    <el-button v-if="scope.row.p_id==0" class="option-btn btn-bd-m" type="primary" size="mini" @click.stop="handleCategory('add',scope.row)">添加子类</el-button>
                                    <el-button class="option-btn btn-bd-s" type="primary" size="mini" @click.stop="handleCategory('edit',scope.row)">编辑</el-button>
                                    <el-button class="option-btn btn-bd-r" type="primary" size="mini" @click.stop="deleteCategory(scope.row)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog class="dialog-export category-dialog" :title="dlg_category.title" :visible.sync="dlg_category.visible" width="534px" @close="closeCategory" :close-on-click-modal="false">
            <el-form ref="formCategory" :model="dlg_category.form" label-width="110px" :rules="dlg_category.rules" @submit.native.prevent>
                <el-form-item prop="name" style="margin-top: 15px;" label="分类名称：" :error="dlg_category.error.name">
                    <el-input size="small" v-model="dlg_category.form.name" placeholder='请输入分类名称' clearable></el-input>
                </el-form-item>

                <el-form-item  prop="p_id" label="所属父级：">
                    <el-select size="small" v-model="dlg_category.form.p_id" placeholder="请选择" >
                        <el-option
                                v-for="item in dlg_category.init_data.parent_name_list"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="sort" label="排序：">
                    <el-input size="small" type='number' v-model="dlg_category.form.sort" placeholder='请输入排序（输入数字）' clearable></el-input>
                </el-form-item>
                <el-form-item prop="status" label="状态：">
                    <el-radio-group v-model="dlg_category.form.status">
                        <el-radio v-for="(item, index) in dlg_category.init_data.status_list" :key="index" :label="item.id">{{item.name}}</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dlg_category.visible = false">取 消</el-button>
                <el-button type="primary" @click="submitCategory()" :loading="dlg_category.btn_loading">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: 'usercenter',
        data() {
            return {
                drawer: false,
                clientHeight:'',
                body_loading:false,
                is_refresh: true,
                //搜索
                form_search:{
                    type:1,
                    name:'',
                    status: -1
                },
                init_data: {
                    status_list: [{id:-1, name: '全部'},{id:1, name: '开启'},{id:2, name: '禁用'}],
                },
                multipleSelection: [],
                paramNodes:{
                    tree:null,
                    treeNode:null,
                    resolve:null
                },
                table_data:{
                    loading: false,
                    list:[],
                    page_info:{
                        page: 1,
                        pageSize: 30,
                        total: 30,
                    },
                    current_list:[]
                },
                dlg_category:{
                    id:'',
                    visible:false,
                    btn_loading:false,
                    api: '',
                    title:'',
                    form:{
                        type:1,
                        name:'',
                        p_id:0,
                        sort:'',
                        status:1
                    },
                    error:{
                        name:''
                    },
                    reset_form: {},
                    init_data:{
                        parent_name_list:[{id:1, name: '顶级'},{id:2, name: '系统管理'},{id:3, name: '用户管理'}],
                        status_list: [{id:1, name: '开启'},{id:2, name: '禁用'}]
                    },
                    rules:{
                        name:{required: true, message: '请输入分类名称', trigger: 'blur'},
                        p_id:{required: true, message: '请选择所属父类', trigger: ['change','blur']},
                        status:{required: true, message: '请选择状态', trigger: ['change','blur']},
                        sort:{required: true, message: '请输入排序（输入数字）', trigger: ['change','blur']}
                    }
                }
            }
        },
        created() {
            document.title = '前台分类管理';
            this.dlg_category.reset_form = Object.assign({}, this.dlg_category.form);
            this.getList();
        },
        methods: {
            searchList(){
                var _this = this;
                _this.table_data.page_info.page = 1;
                _this.getList();
            },
            getList() {
                var _this = this;
                var params = _this.form_search;
                params.p = _this.table_data.page_info.page;
                params.pageSize = _this.table_data.page_info.pageSize;
                _this.table_data.loading = true;
                var status_list = [{id:-1, name: '全部'}];
                var parent_list = [{id:0, name: '父类'}];
                this.$client.get('/adminapi/productcategory/list', params, function(res,message){
                    _this.table_data.list = res.list;
                    _this.table_data.page_info = res.pager;
                    _this.dlg_category.init_data.parent_name_list = parent_list.concat(res.parent_name_list);
                    _this.dlg_category.init_data.status_list = res.status_name_list;
                    _this.init_data.status_list = status_list.concat(res.status_name_list);
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
            loadCategory(tree, treeNode, resolve) {
                var _this = this;
                this.$client.get('/adminapi/productcategory/getdata', {id:tree.id}, function(res,message){
                    _this.table_data.current_list = res.children_list;
                    setTimeout(() => {
                        resolve(_this.table_data.current_list);
                    }, 1000)
                },function(res){

                });
            },
            expandChange(row,index,e){
                this.$refs.multipleTable.store.loadOrToggle(row)
                this.$refs.multipleTable.toggleRowExpansion(row);
            },
            /*handleSelect(selection, row){
             console.log(selection)
             console.log(row)
             },
             handleSelectionChange(val) {
             this.multipleSelection = val;
             console.log(val)
             },*/

            uploadSuccessImg(res, file, fileList){
                this.dlg_category.img_list = fileList;
                this.dlg_category.form.head_img = res.id;
                this.dlg_category.hide_upload = true;
            },
            removeImg(file, fileList){
                this.dlg_category.form.head_img = '';
                this.dlg_category.img_list = [];
                this.dlg_category.hide_upload = false;
            },
            delmultiple(){
                var _this = this;
                var mullist = this.multipleSelection;
                if(mullist.length == 0){
                    _this.$message("请勾选需要删除的分类");
                    return;
                }
                var idList = [];
                for(var i=0;i<mullist.length;i++){
                    idList.push(mullist[i].id);
                }
                var params = {id:idList.join(",")}
                this.$confirm('确定要批量删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/productcategory/delete', params, function(res,message){
                    _this.getList();
                },function(res){

                });
            })
            .catch(() => {});
            },

            handleCategory(type,data){
                this.dlg_category.visible = true;
                if(type == 'add'){
                    this.dlg_category.title = '添加父类';
                    this.dlg_category.api = '/adminapi/productcategory/save';
                    if(data){
                        this.dlg_category.form.p_id = data.id;
                        this.dlg_category.title = '添加子类';
                    }
                }else{
                    this.dlg_category.id= data.id;
                    this.dlg_category.title = '编辑分类';
                    this.dlg_category.form.name = data.name;
                    this.dlg_category.form.p_id = data.p_id;
                    this.dlg_category.form.sort = data.sort;
                    this.dlg_category.form.status = data.status;
                    this.dlg_category.api = '/adminapi/productcategory/save?id=' + data.id;
                }
            },
            deleteCategory(data){
                var _this = this;
                this.$confirm('确定要删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/productcategory/delete', {id:data.id}, function(res,message){
                    if(data.p_id==0){
                        _this.getList();
                    }else{
                        _this.getChildData(_this.$refs.multipleTable.store.states.lazyTreeNodeMap,data.p_id)
                        /*_this.$client.get('/adminapi/productcategory/getdata', {id:data.p_id}, function(res,message){
                            _this.$set(_this.$refs.multipleTable.store.states.lazyTreeNodeMap, data.p_id, res.children_list)
                        },function(res){

                        });*/
                    }
                },function(res){

                });
            })
            .catch(() => {});
            },
            getChildData(lazyTreeNodeMap,p_id){
                var _this = this
                _this.$client.get('/adminapi/productcategory/getdata', {id:p_id}, function(res,message){
                    _this.$set(lazyTreeNodeMap, p_id, res.children_list)
                },function(res){

                });
            },
            getAllAuth(){
                if (this.dlg_category.form.allchecked) {
                    //全选
                    this.$refs.authtree.setCheckedNodes(this.dlg_category.data);
                }else{
                    //取消选中
                    this.$refs.authtree.setCheckedNodes([]);
                    this.$refs.authtree.setCheckedKeys(this.dlg_category.default_list);
                }
            },
            submitCategory(){
                var _this = this;
                _this.$refs['formCategory'].validate((valid) => {
                    if (valid) {
                        this.dlg_category.btn_loading = true;
                        this.$client.post(this.dlg_category.api, this.dlg_category.form, function(res,message){
                            console.log(_this.dlg_category.form.p_id);
                            _this.$message(message);
                            if(_this.dlg_category.form.p_id==0){
                                _this.getList();
                            }else{
                                _this.getChildData(_this.$refs.multipleTable.store.states.lazyTreeNodeMap,_this.dlg_category.form.p_id);
                            }
                            _this.dlg_category.btn_loading = false;
                            _this.dlg_category.visible = false;
                        }, function(message){
                            _this.dlg_category.btn_loading = false;
                            if((typeof message)==='object'){
                                for(var key in message){
                                    _this.dlg_category.error[key] = message[key];
                                }
                            }
                        });
                    } else {
                        console.log('error submit!!');
                return false;
            }
            });
            },
            closeCategory(){
                for(var key in this.dlg_category.form){
                    this.dlg_category.form[key] = this.dlg_category.reset_form[key];
                }
                this.$nextTick(()=>{
                    this.$refs.formCategory.clearValidate();
            })
            },
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            }
        }
    }
</script>
<style>
    .el-drawer__header{
        margin-bottom: 0;
        padding-bottom: 20px;
        border-bottom: 1px solid #e9e9e9;
    }
    .el-drawer,.el-drawer__header,.el-drawer__header>:first-child{
        outline: none !important;
    }
    .hide-upload .el-upload--picture-card {
        display: none;
    }
    .page-category .el-upload--picture-card{
        line-height: 80px;
    }
    .page-category .el-upload--picture-card,.el-upload-list--picture-card .el-upload-list__item{
        width: 80px;
        height: 80px;
    }

    .domain-dialog .el-form-item__label:before,.forward-dialog .el-form-item__label:before{
        display: none;
    }
    .approve-dialog .el-dialog__footer{
        text-align: center;
    }
    .error-dialog .el-dialog__header{
        border-bottom: none;
        padding-top: 25px;
        text-align: center;
    }
</style>
<style scoped>

</style>